import type { PermissionCode } from '@core-frontend/core-frontend';
import { useHasPermission } from '@core-frontend/core-frontend';
import { useLocation, useNavigate } from 'react-router-dom';

type PermissionGuardProps = {
  permissions: PermissionCode | PermissionCode[];
};

const PermissionGuard = ({
  children,
  permissions,
}: React.PropsWithChildren<PermissionGuardProps>) => {
  const { hasPermission } = useHasPermission();
  const hasAccess = hasPermission(permissions, { matchAll: true });

  const navigate = useNavigate();
  const location = useLocation();

  if (!hasAccess) {
    const handleRedirect = () => {
      const previousPage = location.state?.from || '/';
      navigate(previousPage, { replace: true });
    };

    handleRedirect();
    return null;
  }

  return children;
};

export default PermissionGuard;
